import { SelectItem } from "@mantine/core/lib/Select/types";
import { sortBy } from "lodash";

import { GetMessageTemplatesQuery } from "../../graphql/generated.ts";

export type MessageTemplate = GetMessageTemplatesQuery["messageTemplates"][0];

export const getTemplateOptions = (
  data: Pick<MessageTemplate, "id" | "name">[] | null | undefined
): SelectItem[] => {
  return sortBy(
    data?.map((template) => ({
      value: String(template.id),
      label: template.name,
    })) ?? [],
    "label"
  );
};
